import { createElementBlock as e, openBlock as o, createElementVNode as l } from "vue";
import t from "./index289.js";
const a = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function r(s, c, f, h, i, p) {
  return o(), e("svg", n, c[0] || (c[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#FFF9D5",
        d: "M30.165 25.266c.558-4.884 4.734-8.693 9.862-8.693 0 5.402 4.466 9.781 9.973 9.781 0 3.271-1.653 6.15-4.169 7.925L37 34.5l-6.835-9.234Z"
      }),
      l("path", {
        fill: "#E5F2F9",
        d: "M40.918 32.411c-1.141 0-2.216.23-3.156.692-.705-4.555-4.734-8.055-9.57-8.055-5.272 0-9.57 4.16-9.704 9.309-3.156.396-5.607 3.036-5.607 6.305-.003 3.5 2.885 6.338 6.444 6.338h21.59c4.096 0 7.42-3.267 7.42-7.296.003-4.026-3.321-7.293-7.417-7.293Z"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M40.027 15.323c.69 0 1.25.56 1.25 1.25 0 4.706 3.9 8.531 8.723 8.531.69 0 1.25.56 1.25 1.25 0 3.095-1.319 5.97-3.555 8.025a8.413 8.413 0 0 1 1.89 5.325c0 4.724-3.887 8.546-8.67 8.546h-21.59c-4.245 0-7.697-3.394-7.694-7.588 0-3.444 2.291-6.362 5.492-7.295l.19-.053.015-.124c.694-5.21 5.16-9.248 10.574-9.388l.29-.004c.322 0 .641.014.956.041 1.163-4.92 5.615-8.516 10.879-8.516ZM28.192 26.298c-4.584 0-8.337 3.61-8.455 8.092a1.25 1.25 0 0 1-1.094 1.207c-2.577.324-4.512 2.472-4.512 5.066-.002 2.803 2.32 5.087 5.194 5.087h21.59c3.411 0 6.17-2.713 6.17-6.046.002-1.703-.72-3.245-1.88-4.345a1.226 1.226 0 0 1-.356-.308 6.198 6.198 0 0 0-3.931-1.39c-.964 0-1.85.193-2.605.564a1.25 1.25 0 0 1-1.786-.93c-.52-3.364-3.121-6.031-6.429-6.784a1.253 1.253 0 0 1-.37-.074 8.455 8.455 0 0 0-1.536-.139ZM38.858 17.9l-.139.02c-3.477.516-6.29 3.062-7.12 6.414 3.306 1.07 5.946 3.65 7.012 6.951l.049.16.151-.04a8.816 8.816 0 0 1 1.745-.237l.362-.007c1.83 0 3.53.56 4.93 1.516a8.44 8.44 0 0 0 2.774-4.868l.044-.283-.117-.013c-5.033-.64-9.028-4.558-9.679-9.512l-.012-.101ZM11.5 19.75c.647 0 1.18.492 1.244 1.122l.006.128v1.25H14a1.25 1.25 0 0 1 .128 2.494L14 24.75h-1.25V26a1.25 1.25 0 0 1-2.494.128L10.25 26v-1.25H9a1.25 1.25 0 0 1-.128-2.494L9 22.25h1.25V21c0-.69.56-1.25 1.25-1.25Zm9.486-13.42c.647 0 1.18.491 1.243 1.121l.007.128v2.25h2.25a1.25 1.25 0 0 1 .128 2.494l-.128.006h-2.25v2.25a1.25 1.25 0 0 1-2.494.128l-.006-.128v-2.25h-2.25a1.25 1.25 0 0 1-.128-2.493l.128-.007h2.25V7.58c0-.69.56-1.25 1.25-1.25Z"
      })
    ], -1)
  ]));
}
const v = /* @__PURE__ */ t(a, [["render", r]]);
export {
  v as default
};
